var plugin_rtlignore_default = {
  "alignLeft": "gVkHu",
  "textWrapNowrap": "uABiv",
  "alignRight": "Et2Qb",
  "alignCenter": "XBdto",
  "sizeFullWidth": "_68lCX",
  "renderedInTable": "L0RK2",
  "sizeOriginal": "c9ntn",
  "sizeContent": "evrar",
  "sizeSmall": "XANm0",
  "sizeSmallCenter": "B180p",
  "flex": "ezo1N",
  "atomic": "BCyr-",
  "embed": "_8a1YZ",
  "horizontalScrollbar": "HKzRE",
  "pluginContainerMobile": "_7Pstz"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
